type GaConfig = {
  cookie_flags?: string;
  anonymize_ip?: boolean; // optional; GA4 does this by default
  send_page_view: boolean;
  accountId?: string | number | null;
  version?: string;
};

// Track initialized tracking IDs to prevent duplicate gtag('config') calls
// This is important because useSetupAnalytics can be called multiple times
// (e.g., when consent changes or widgetContext updates), and we only want
// to configure each GA4 property once per session.
const initializedTrackingIds = new Set<string>();
const initializeGoogleAnalytics4 = (
  trackingId: string,
  configOptions: GaConfig,
): void => {
  if (!trackingId || !trackingId.trim()) return;
  if (initializedTrackingIds.has(trackingId)) return;

  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('config', trackingId, configOptions as any);
  initializedTrackingIds.add(trackingId);
};

export default initializeGoogleAnalytics4;
